<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="page-container">
        <div class="footer-columns">
          <div class="footer-column">
            <h3>{{ $t('footer.about.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/about">{{ $t('footer.about.companyIntro') }}</router-link></li>
              <li><router-link to="/about/history">{{ $t('footer.about.history') }}</router-link></li>
<!--              <li><router-link to="/about/team">{{ $t('footer.about.team') }}</router-link></li>-->
<!--              <li><router-link to="/about/organization">{{ $t('footer.about.organization') }}</router-link></li>-->
<!--              <li><router-link to="/about/honors">{{ $t('footer.about.honors') }}</router-link></li>-->
            </ul>
          </div>

          <div class="footer-column">
            <h3>{{ $t('footer.business.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/boxs">{{ $t('footer.business.overview') }}</router-link></li>
<!--              <li><router-link to="/boxs/software">{{ $t('footer.business.softwareDev') }}</router-link></li>-->
<!--              <li><router-link to="/boxs/integration">{{ $t('footer.business.systemIntegration') }}</router-link></li>-->
<!--              <li><router-link to="/boxs/consulting">{{ $t('footer.business.techConsulting') }}</router-link></li>-->
<!--              <li><router-link to="/boxs/projects">{{ $t('footer.business.projects') }}</router-link></li>-->
            </ul>
          </div>

          <div class="footer-column">
            <h3>{{ $t('footer.news.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/news">{{ $t('footer.news.newsInfo') }}</router-link></li>
<!--              <li><router-link to="/news/media">{{ $t('footer.news.mediaReports') }}</router-link></li>-->
<!--              <li><router-link to="/news/video">{{ $t('footer.news.videoCenter') }}</router-link></li>-->
<!--              <li><router-link to="/product/social">{{ $t('footer.news.socialResponsibility') }}</router-link></li>-->
            </ul>
          </div>

          <div class="footer-column">
            <h3>{{ $t('footer.recruit.title') }}</h3>
            <ul class="footer-links">
              <li><router-link to="/recruits">{{ $t('footer.recruit.positions') }}</router-link></li>
<!--              <li><router-link to="/recruits/campus">{{ $t('footer.recruit.campus') }}</router-link></li>-->
<!--              <li><router-link to="/recruits/social">{{ $t('footer.recruit.social') }}</router-link></li>-->
<!--              <li><router-link to="/recruits/intern">{{ $t('footer.recruit.intern') }}</router-link></li>-->
            </ul>
          </div>

          <div class="footer-column contact-column">
            <h3>{{ $t('footer.contact.title') }}</h3>
            <ul class="contact-info">
              <li><i class="el-icon-location"></i>{{ $t('footer.contact.address') }}</li>
              <li><i class="el-icon-phone"></i>{{ $t('footer.contact.phone') }}</li>
              <li><i class="el-icon-document"></i>{{ $t('footer.contact.fax') }}</li>
              <li><i class="el-icon-message"></i> {{ $t('footer.contact.emailName') }}@{{ $t('footer.contact.emailDomain') }}</li>
            </ul>
            <div class="qrcode-container">
              <div class="qrcode">
                <img src="../assets/logo.png" alt="微信公众号" class="qrcode-img" />
                <p>{{ $t('footer.contact.wechat') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-bottom-section">
          <div class="footer-bottom-info">
            <div class="footer-logo">
              <img src="../assets/logo.png" alt="和祥泰数码科技有限公司" class="logo-img" />
              <div class="company-info">
                <h2>{{ $t('footer.company.name') }}</h2>
                <p>{{ $t('footer.company.slogan') }}</p>
              </div>
            </div>

<!--            <div class="stock-info">-->
<!--              <p class="stock-title">{{ $t('footer.stock.title') }}</p>-->
<!--              <div class="stock-grid">-->
<!--                <div class="stock-item">-->
<!--                  <span class="stock-code">{{ $t('footer.stock.code') }}：xxxxxx</span>-->
<!--                  <span class="stock-price">20.36 <i class="el-icon-top" style="color:#ff4d4f"></i> +0.42</span>-->
<!--                  <span class="stock-time">{{ $t('footer.stock.time') }}：{{ currentTime }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="page-container">
        <div class="copyright">
          <p><a href="https://beian.miit.gov.cn" target="_blank">©鲁ICP备2025180637号</a> {{ currentYear }} {{ $t('footer.company.name') }}（中国）有限公司 {{ $t('footer.copyright.rights') }}</p><!--          <p>{{ $t('footer.copyright.icp') }}<span>xxxxxxx</span> | {{ $t('footer.copyright.police') }} <span>xxxxxxx</span></p>-->
        </div>
        <div class="footer-nav">
          <router-link to="/legal/privacy">{{ $t('footer.nav.privacy') }}</router-link>
          <router-link to="/legal/terms">{{ $t('footer.nav.terms') }}</router-link>
          <router-link to="/sitemap">{{ $t('footer.nav.sitemap') }}</router-link>
          <router-link to="/touch">{{ $t('footer.nav.contact') }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const currentYear = computed(() => new Date().getFullYear());

const currentTime = ref('');

const updateCurrentTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  currentTime.value = `${year}-${month}-${day} ${hours}:${minutes}`;
};

onMounted(() => {
  updateCurrentTime();
  setInterval(updateCurrentTime, 60000);
});
</script>

<style lang="scss" scoped>
/* 样式保持你原本的代码，不做任何改动 */
.footer {
  background-color: #f5f5f5;
  color: #333;

  .footer-main {
    padding: 60px 0 30px;

    .footer-columns {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 30px;
      margin-bottom: 40px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }
    }

    .footer-column {
      h3 {
        font-size: 18px;
        color: #163C7D;
        margin-bottom: 20px;
        font-weight: 500;
        position: relative;
        padding-bottom: 12px;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 2px;
          background-color: #163C7D;
        }
      }

      .footer-links {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 12px;

          a {
            color: #666;
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s;
            position: relative;
            padding-left: 15px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 8px;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #ccc;
            }

            &:hover {
              color: #163C7D;
              padding-left: 18px;

              &::before {
                background-color: #163C7D;
              }
            }
          }
        }
      }

      &.contact-column {
        @media (max-width: 1200px) {
          grid-column: span 3;
        }

        @media (max-width: 768px) {
          grid-column: span 2;
        }

        @media (max-width: 576px) {
          grid-column: span 1;
        }

        .contact-info {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-bottom: 12px;
            display: flex;
            align-items: flex-start;
            color: #666;
            font-size: 14px;

            i {
              color: #163C7D;
              margin-right: 10px;
              font-size: 16px;
              margin-top: 2px;
            }
          }
        }

        .qrcode-container {
          margin-top: 20px;
          display: flex;
          align-items: center;

          .qrcode {
            text-align: center;

            .qrcode-img {
              width: 100px;
              height: 100px;
              padding: 5px;
              border: 1px solid #e0e0e0;
              background-color: #fff;
            }

            p {
              margin: 8px 0 0;
              font-size: 13px;
              color: #666;
            }
          }
        }
      }
    }

    .footer-bottom-section {
      padding-top: 30px;
      border-top: 1px solid #e0e0e0;

      .footer-bottom-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (max-width: 992px) {
          flex-direction: column;
          gap: 30px;
          align-items: flex-start;
        }

        .footer-logo {
          display: flex;
          align-items: center;

          .logo-img {
            width: 60px;
            height: 60px;
            margin-right: 15px;
          }

          .company-info {
            h2 {
              font-size: 20px;
              color: #163C7D;
              margin: 0 0 5px;
            }

            p {
              font-size: 14px;
              color: #666;
              margin: 0;
            }
          }
        }

        .stock-info {
          .stock-title {
            font-size: 16px;
            color: #163C7D;
            margin-bottom: 10px;
            font-weight: 500;
          }

          .stock-grid {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 15px;

            .stock-item {
              background-color: #fff;
              padding: 15px;
              border-radius: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
              display: flex;
              flex-direction: column;

              .stock-code {
                font-size: 14px;
                color: #666;
                margin-bottom: 8px;
              }

              .stock-price {
                font-size: 18px;
                font-weight: 600;
                color: #333;
                margin-bottom: 5px;

                i {
                  font-size: 14px;
                  margin-left: 5px;
                }
              }

              .stock-time {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }

  .footer-bottom {
    background-color: #163C7D;
    color: #fff;
    padding: 20px 0;

    .page-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 15px;
      }
    }

    .copyright {
      p {
        margin: 0;
        font-size: 14px;
        opacity: 0.8;

        &:first-child {
          margin-bottom: 5px;
        }

        span {
          color: #ff9800;
        }
      }
    }

    .footer-nav {
      display: flex;
      gap: 20px;

      a {
        color: #fff;
        opacity: 0.8;
        text-decoration: none;
        font-size: 14px;

        &:hover {
          opacity: 1;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
